import { useCallback, useRef } from 'react';
const MENU_ITEM_HEIGHT = 36;
const MENU_ITEM_WITH_SUBTEXT_HEIGHT = 56;

/**
 * A hook used to manage all logic needed for a virtualized Dropdown.
 * Returns properties in the format react-virtual expects.
 */
export default (_ref => {
  let {
    menuItems,
    isGroupHeader
  } = _ref;
  const virtualParentRef = useRef(null);
  const estimateVirtualItemSize = useCallback(index => {
    const item = menuItems[index];
    if (isGroupHeader(item)) {
      return 32;
    }
    return item.subtext ? MENU_ITEM_WITH_SUBTEXT_HEIGHT : MENU_ITEM_HEIGHT;
  }, [isGroupHeader, menuItems]);
  return {
    /**
     * The total number of items in the dropdown.
     */
    size: menuItems.length,
    /**
     * A ref to the parent element of the virtualized menu.
     */
    parentRef: virtualParentRef,
    /**
     * A function to estimate the side of virtualized menu items.  Used to calculate the height of the virtualized menu.
     */
    estimateSize: estimateVirtualItemSize,
    /**
     * The amount of items to render outside of the visible area of the virtualized menu.
     * A smaller number will increase performance.  A larger number will increase scroll appearance by showing fewer empty items.
     */
    overscan: 10
  };
});
//# sourceMappingURL=useVirtualProps.js.map